import { ref } from 'vue'
import useNotification from '@/composables/useNotification.js'
import { api } from '@/helpers/api'
import { useValidation } from '@/composables/utils/useValidation'
import { useAuth } from '@/composables/auth/useAuth'
import { useArtistClaimProfile } from '@/composables/features/artist-claim-profile/useArtistClaimProfile'

const URLS = {
    xhr: {
        mutate: {
            isUser: '/api/profile/is-user'
        }
    }
}

export const useWelcomeStep = () => {
    const { isValid } = useValidation()
    const { notification } = useNotification()
    const { load, authedRegister, userValues, updateProfileOrEventSteps, handleShowLoginModal, toggleAuthModal } =
        useAuth()
    const { toggleClaimProfile, skipFirstStep } = useArtistClaimProfile()

    const formValues = ref({
        email: ''
    })
    async function handleInitializeAuth(v) {
        if (isValid(v)) {
            try {
                load.value = true
                const data = await api({
                    method: 'post',
                    url: URLS.xhr.mutate.isUser,
                    data: formValues.value
                })
                _redirectNextStep(data)
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Email not valid.')
        }
    }
    function _redirectNextStep(data) {
        if (data?.user && !data.user.unclaimed) {
            userValues.value.email = data.user.email
            userValues.value.firstName = data.user.first_name
            authedRegister.value = true
            handleShowLoginModal()
        } else if (data?.user && data.user.unclaimed) {
            toggleAuthModal(false)
            toggleClaimProfile(true)
            skipFirstStep(data.user.email)
        } else {
            userValues.value.email = formValues.value.email

            updateProfileOrEventSteps('initial-register', 'initial-register')
        }
    }
    return {
        load,
        formValues,
        handleInitializeAuth
    }
}
